import firebaseKit from "../firebase/firebaseKit";
import ChatMessage from "./ChatMessage";
import firebase from "firebase/app";
import "firebase/database";
import { ChatMessageEnums } from "./index";
import { child } from "firebase/database";
import { getRef, refs } from "../firebase/firebaseRefKit";

export default class PublicChatMessage extends ChatMessage {
  /**
   *
   * @param {object} me me object from UserContext, only needed when creating new message
   * @param {object} payload firebase message data
   * @param {object} urlParams contains data needed for building firebase url, firebaseID only needed for updating existing message
   */
  constructor({
    me = null,
    payload: {
      author,
      epoch = firebaseKit.util.getServerTimestamp(),
      message = "",
      isHidden = false,
      isHighlighted = false,
      timeStamp = new Date().toGMTString(),
      kind = ChatMessageEnums.TEXT,
    },

    options = {},

    urlParams: { eventSlug, pageSlug, firebaseID },
  }) {
    super(options);

    if (me) {
      this.author = {
        displayName: this._getDisplayName(me),
        userId: me?.user?.id,
        eventUserId: me?.id,
        isModerator: me?.isModerator || false,
      };
    } else if (author) {
      this.author = this._camelCaseify(author);
    } else {
      throw new Error("No author specified for message");
    }

    this.message = message;
    this.epoch = epoch;
    this.timeStamp = timeStamp;
    this.isHidden = isHidden;
    this.isHighlighted = isHighlighted;
    this.kind = options.kind || kind;

    this._urlParams = {
      eventSlug,
      pageSlug,
      firebaseID,
    };

    this.type = "public";
  }

  _getMessageRef() {
    const { firebaseID } = this._urlParams;
    if (!firebaseID)
      throw new Error("Can't get Firebase ref without firebaseID");

    const ref = child(this._getPageRef(), `messages/${firebaseID}`);
    return ref;
  }

  _getInboxRef() {
    const ref = child(this._getPageRef(), "messages");
    return ref;
  }

  _getPageRef() {
    const { eventSlug, pageSlug } = this._urlParams;
    if (!eventSlug || !pageSlug)
      throw new Error("Can't get Firebase ref without eventSlug and pageSlug");
    const ref = getRef(refs["public-messages"].$eventSlug.url.$pageSlug, {
      eventSlug,
      pageSlug,
    });
    if (ref) return ref
  }

  _getPayload() {
    const { author, message, isHighlighted, isHidden, epoch, timeStamp } = this;

    return {
      author,
      message,
      isHighlighted,
      isHidden,
      epoch,
      timeStamp,
    };
  }

  getEventUrl() {
    const { eventSlug } = this._urlParams;
    if (!eventSlug) throw new Error("Can't get Event url without eventSlug");
    return `public-messages/${eventSlug}`;
  }

  setIsHighlighted(value) {
    this.isHighlighted = Boolean(value);
    this.update();
  }

  setIsHidden(value) {
    this.isHidden = Boolean(value);
    this.update();
  }
}
